import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ListResponse } from "../interfaces/list-response.interface";
import {
  Account,
  Identify,
  Investment,
  OpenFinance,
  ResponseOpenFinance,
  Transaction
} from "../interfaces/open-finance.interface";
import { AuthenticationService } from "./auth.service";

export interface DataGetItems {
  item_uuid: string;
  client_uuid: string;
}

@Injectable({
  providedIn: "root"
})
export class ApiServiceOpenFinance {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) { }

  private optionsHeader = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25",
      Authorization: this.authenticationService.getBearerToken()
    })
  };

  private optionsHeaderNoAuth = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25"
    })
  };

  getOpenFinanceWithClient() {
    return this.http.get<ListResponse<OpenFinance[]>>(`/open-finance/client?total_page=999999`, this.optionsHeader);
  }

  addItemOpenFinance(data: DataGetItems) {
    return this.http.post(`/open-finance/client/add-item`, data, this.optionsHeaderNoAuth);
  }

  getItems(idClient: string) {
    return this.http.post<OpenFinance[]>(
      `/open-finance/client/get-items`,
      { client_uuid: idClient },
      this.optionsHeaderNoAuth
    );
  }

  getAccountsId(id: string) {
    return this.http.get<ResponseOpenFinance<Account[]>>(`/open-finance/client/accounts/${id}`, this.optionsHeader);
  }

  getTransactionsId(id: string) {
    return this.http.get<ListResponse<Transaction[]>>(`/open-finance/client/transactions/${id}`, this.optionsHeader);
  }

  getInvestmentsId(id: string) {
    return this.http.get<ResponseOpenFinance<Investment[]>>(
      `/open-finance/client/investments/${id}`,
      this.optionsHeader
    );
  }

  getIdentifyId(id: string) {
    return this.http.get<ResponseOpenFinance<Identify[]>>(`/open-finance/client/identify/${id}`, this.optionsHeader);
  }
}
